import React from 'react';
import { Box, useTheme } from '@mui/material';

interface RowDividerProps {
  inset?: string;
}

const RowDivider: React.FC<RowDividerProps> = ({ inset = '0px' }) => {
  const theme = useTheme();

  return (
    <Box sx={{ position: 'relative', height: 0 }}>
      <Box
        sx={{
          position: 'absolute',
          left: inset,
          right: inset,
          height: '1px',
          backgroundColor: theme.palette.secondary.disabled,
        }}
      />
    </Box>
  );
};

export default RowDivider;
